import moment from "moment";

// init function uses the resolved promises from all our api requests to build up a single object, so we only call setState once when the component mounts
export const onSubmit = async (
  props,
  handleAlertModal,
  values,
  customFields
) => {
  const { apiUrl, facilities, userId, token } = props;
  const {
    assetTag,
    category,
    description,
    note,
    quantity,
    selectedAssetClassifications,
    selectedFacility,
    selectedZone,
    status,
    timeNeeded,
    timeCreatedUser,
    xCoordinate,
    yCoordinate,
  } = values;

  const { location, name: facilityName } = facilities[selectedFacility.value];
  const { facilityId, latitude, longitude } = location;
  const body = {
    assetMode: "Asset",
    category: category.value,
    customMap: {},
    classificationMap: selectedAssetClassifications,
    location,
    timeNeeded: timeNeeded?.value
      ? moment(timeNeeded.value, "MM/DD/yyyy").format("YYYYMMDDHHmm")
      : "",
    timeCreatedUser: timeCreatedUser?.value
      ? moment(timeCreatedUser.value, "MM/DD/yyyy").format("YYYYMMDDHHmm")
      : "",
    facility: facilityName,
    propertiesMap: {
      category: category.value,
      description: description.value,
      assetDetails: note.value,
    },
    quantity,
    tag: assetTag.value,
    zone: {
      zoneId: selectedZone.value,
    },
    xyz: {
      x: xCoordinate.value,
      y: yCoordinate.value,
    },
  };

  Object.keys(customFields).forEach((field) => {
    const { name, value = "" } = customFields[field];
    if (
      value?.length > 0 ||
      typeof value === "number" ||
      value instanceof Date
    ) {
      body.customMap[name] = value;
    }
  });

  const results = await fetch(`${apiUrl}assets/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then(async (response) => {
      if (response.error) {
        return response;
      }

      const { assetId } = response.asset;
      const updateAssetBody = {
        action: status.value,
        appUserId: userId,
        facilityId: facilityId,
        facility: facilityName,
        latitude,
        longitude,
        zone: {
          zoneId: selectedZone.value,
        }
      };
      const updateAsset = await fetch(`${apiUrl}assets/${assetId}/action`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
        body: JSON.stringify(updateAssetBody),
      })
        .then(() => {
          handleAlertModal({
            modalText: "Asset Successfully Added",
            alertModalColor: "success",
          });
          return response.asset;
        })
        .catch((error) => {
          handleAlertModal({
            alertModalContent: error.toString(),
            alertModalSeverity: "error",
            alertModalTitle: "Error",
          });
        });

      return updateAsset;
    })
    .catch((error) => {
      handleAlertModal({
        modalText: error.toString(),
        alertModalColor: "error",
      });
    });

  return results;
};
